module.exports = __webpack_public_path__ + "img/function_04.8b4b6caf.png";